<template>
  <div class="space-y-6">
    <!-- 统计卡片 -->
    <div class="grid grid-cols-2 md:grid-cols-5 gap-4">
      <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-5">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm text-neutral-500">工具总数</span>
          <i class="fa fa-cube text-primary text-xl"></i>
        </div>
        <div class="text-2xl font-bold text-neutral-900">
          {{ stats.toolCount || 0 }}
        </div>
        <div class="text-xs text-green-600 mt-1">
          <i class="fa fa-arrow-up mr-1"></i>今日 +{{ stats.toolToday || 0 }}
        </div>
      </div>

      <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-5">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm text-neutral-500">访问总量</span>
          <i class="fa fa-eye text-teal-500 text-xl"></i>
        </div>
        <div class="text-2xl font-bold text-neutral-900">
          {{ stats.toolViewTotal || 0 }}
        </div>
        <div class="text-xs text-neutral-500 mt-1">
          下载总量 {{ stats.toolDownTotal || 0 }}
        </div>
      </div>

      <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-5">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm text-neutral-500">需求总数</span>
          <i class="fa fa-lightbulb-o text-secondary text-xl"></i>
        </div>
        <div class="text-2xl font-bold text-neutral-900">
          {{ stats.demandCount || 0 }}
        </div>
        <div class="text-xs text-neutral-500 mt-1">
          已解决 {{ stats.demandYJJ || 0 }} / 进行中 {{ stats.demandDJJ || 0 }}
        </div>
      </div>

      <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-5">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm text-neutral-500">留言总数</span>
          <i class="fa fa-comments-o text-orange-500 text-xl"></i>
        </div>
        <div class="text-2xl font-bold text-neutral-900">
          {{ stats.toolLY || 0 }}
        </div>
        <div class="text-xs text-blue-600 mt-1">
          本周 +{{ stats.toolLYWeek || 0 }}
        </div>
      </div>

      <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-5">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm text-neutral-500">用户总数</span>
          <i class="fa fa-users text-purple-500 text-xl"></i>
        </div>
        <div class="text-2xl font-bold text-neutral-900">
          {{ stats.userCount || 0 }}
        </div>
        <div class="text-xs text-green-600 mt-1">
          <i class="fa fa-arrow-up mr-1"></i>今日 +{{ stats.userToday || 0 }}
        </div>
      </div>
    </div>

    <!-- 详细数据 -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- 工具统计 -->
      <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
        <h3 class="text-lg font-bold text-neutral-900 mb-4 flex items-center">
          <i class="fa fa-cube text-primary mr-2"></i>工具统计
        </h3>
        <div class="space-y-4">
          <div
            class="flex justify-between items-center py-2 border-b border-neutral-100"
          >
            <span class="text-neutral-600">待审批</span>
            <span class="font-bold text-yellow-600">{{
              stats.toolSP || 0
            }}</span>
          </div>
          <div
            class="flex justify-between items-center py-2 border-b border-neutral-100"
          >
            <span class="text-neutral-600">已上架</span>
            <span class="font-bold text-green-600">{{
              stats.toolSJ || 0
            }}</span>
          </div>
          <div
            class="flex justify-between items-center py-2 border-b border-neutral-100"
          >
            <span class="text-neutral-600">已拒绝</span>
            <span class="font-bold text-red-600">{{ stats.toolJJ || 0 }}</span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-neutral-600">今日新增</span>
            <span class="font-bold text-primary">{{
              stats.toolToday || 0
            }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-t border-neutral-100">
            <span class="text-neutral-600"><i class="fa fa-eye mr-1 text-teal-500"></i>访问总量</span>
            <span class="font-bold text-teal-600">{{
              stats.toolViewTotal || 0
            }}</span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-neutral-600"><i class="fa fa-download mr-1 text-blue-500"></i>下载总量</span>
            <span class="font-bold text-blue-600">{{
              stats.toolDownTotal || 0
            }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-t border-neutral-100">
            <span class="text-neutral-600">本周新增</span>
            <span class="font-bold text-primary">{{
              stats.toolWeek || 0
            }}</span>
          </div>
        </div>
      </div>

      <!-- 需求统计 -->
      <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
        <h3 class="text-lg font-bold text-neutral-900 mb-4 flex items-center">
          <i class="fa fa-lightbulb-o text-secondary mr-2"></i>需求统计
        </h3>
        <div class="space-y-4">
          <div
            class="flex justify-between items-center py-2 border-b border-neutral-100"
          >
            <span class="text-neutral-600">进行中</span>
            <span class="font-bold text-yellow-600">{{
              stats.demandDJJ || 0
            }}</span>
          </div>
          <div
            class="flex justify-between items-center py-2 border-b border-neutral-100"
          >
            <span class="text-neutral-600">已解决</span>
            <span class="font-bold text-green-600">{{
              stats.demandYJJ || 0
            }}</span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-neutral-600">今日新增</span>
            <span class="font-bold text-secondary">{{
              stats.demandToday || 0
            }}</span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-neutral-600">本周新增</span>
            <span class="font-bold text-secondary">{{
              stats.demandToweek || 0
            }}</span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-neutral-600">总回复数</span>
            <span class="font-bold text-neutral-900">{{
              stats.demandReplay || 0
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 近期趋势 -->
    <!-- <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
      <h3 class="text-lg font-bold text-neutral-900 mb-4 flex items-center">
        <i class="fa fa-line-chart text-primary mr-2"></i>近期发布趋势
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="bg-neutral-50 rounded-lg p-4 text-center">
          <div class="text-sm text-neutral-500 mb-1">今日发布工具</div>
          <div class="text-3xl font-bold text-primary">{{ stats.toolToday || 0 }}</div>
          <div class="text-xs text-neutral-400 mt-1">较昨日 {{ stats.toolTrend > 0 ? '+' : '' }}{{ stats.toolTrend || 0 }}%</div>
        </div>
        <div class="bg-neutral-50 rounded-lg p-4 text-center">
          <div class="text-sm text-neutral-500 mb-1">本周发布工具</div>
          <div class="text-3xl font-bold text-primary">{{ stats.toolWeek || 0 }}</div>
          <div class="text-xs text-neutral-400 mt-1">平均 {{ ((stats.toolWeek || 0) / 7).toFixed(1) }} /天</div>
        </div>
        <div class="bg-neutral-50 rounded-lg p-4 text-center">
          <div class="text-sm text-neutral-500 mb-1">本月发布工具</div>
          <div class="text-3xl font-bold text-primary">{{ stats.toolMonth || 0 }}</div>
          <div class="text-xs text-neutral-400 mt-1">累计数据</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "DashboardPanel",
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },
};
</script>
